(function() {
  'use strict';

  if (window.__metalConflictLoaded) return;
  window.__metalConflictLoaded = true;

  const CONFIG = {
    bannerId: 'metal-conflict-banner',
    checkoutSelectors: [
      'button[name="checkout"]',
      'input[name="checkout"]',
      '#myBtn',
      '#checkout',
      '#cart-checkout-button',
      '.cart__checkout-button',
      '[data-checkout-btn]',
      '.cart-checkout-button',
      '#Finalizar-pedido',
      '.cart__cta'
    ]
  };

  let debounceTimer = null;
  function scheduleCheck(delay) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(checkCartConflict, delay || 300);
  }

  function hasToken(str, token) {
    const pattern = new RegExp('(^|[^a-z0-9])' + token + '($|[^a-z0-9])', 'i');
    return pattern.test(str);
  }

  function detectGold(handle, type) {
    return (
      hasToken(handle, 'oro')    ||
      hasToken(handle, 'or')     ||
      hasToken(handle, 'gold')   ||
      hasToken(handle, 'dorado') ||
      hasToken(type,   'oro')    ||
      hasToken(type,   'gold')
    );
  }

  function detectSilver(handle, type) {
    return (
      hasToken(handle, 'argent') ||
      hasToken(handle, 'plata')  ||
      hasToken(handle, 'silver') ||
      hasToken(type,   'plata')  ||
      hasToken(type,   'silver')
    );
  }

  async function checkCartConflict() {
    try {
      const response = await fetch('/cart.js?_=' + Date.now());
      const cart = await response.json();

      let hasGold   = false;
      let hasSilver = false;

      cart.items.forEach(function(item) {
        const handle = (item.handle       || '').toLowerCase();
        const type   = (item.product_type || '').toLowerCase();

        const gold   = detectGold(handle, type);
        const silver = detectSilver(handle, type);

        if (gold)   hasGold   = true;
        if (silver) hasSilver = true;
      });

      if (hasGold && hasSilver) {
        showBanner();
        disableCheckout();
      } else {
        hideBanner();
        enableCheckout();
      }

    } catch (err) {
      console.error('[MetalConflict]', err);
    }
  }

  function createBanner() {
    const div = document.createElement('div');
    div.id = CONFIG.bannerId;
    div.style.cssText = `
      display:flex; align-items:flex-start; gap:12px;
      background:#FFF8E1; border:2px solid #F39C12;
      border-radius:10px; padding:16px 18px;
      margin:20px; font-size:14px;
      line-height:1.6; color:#333;
    `;
    div.innerHTML = `
      <svg width="22" height="22" viewBox="0 0 24 24"
           fill="none" style="flex-shrink:0;margin-top:2px">
        <circle cx="12" cy="12" r="10"
                stroke="#E67E22" stroke-width="2"/>
        <line x1="12" y1="8" x2="12" y2="13"
              stroke="#E67E22" stroke-width="2"
              stroke-linecap="round"/>
        <circle cx="12" cy="16.5" r="1" fill="#E67E22"/>
      </svg>
      <div>
        <strong style="color:#C0392B;">
          El oro y la plata no se pueden pedir juntos
        </strong>
        (tienen tipos de IVA diferentes).<br>
        Por favor, incluye solo un tipo de metal en esta
        cesta, confirma tu pedido y, a continuación, crea
        una nueva cesta para el oro metal. Los precios
        seguirán siendo los mismos y
        <strong>el envío será gratuito.</strong>
      </div>
    `;
    return div;
  }

  function showBanner() {
    const existing = document.getElementById(CONFIG.bannerId);
    if (existing) existing.remove();

    const banner = createBanner();

    const cartPageForm = document.querySelector('#CartPageForm');
    if (cartPageForm && cartPageForm.parentNode) {
      cartPageForm.parentNode.insertBefore(banner, cartPageForm);
      return;
    }

    const genericCartForm = document.querySelector('form[action="/cart"]');
    if (genericCartForm) {
      genericCartForm.insertBefore(banner, genericCartForm.firstChild);
      return;
    }

    const drawerSelectors = [
      'cart-drawer',
      '.cart-drawer__inner',
      '.cart__drawer',
      '[data-cart-drawer]',
      '.cart-drawer',
      '#cart-drawer',
      '.js-cart-drawer'
    ];

    const pageSelectors = [
      '.cart_data-wrapper',
      '.cart__items',
      '#cart-items',
      '[data-cart-items]',
      '.cart-items'
    ];

    for (const sel of drawerSelectors) {
      const el = document.querySelector(sel);
      if (el) { el.insertBefore(banner, el.firstChild); return; }
    }

    for (const sel of pageSelectors) {
      const el = document.querySelector(sel);
      if (el) { el.parentNode.insertBefore(banner, el); return; }
    }
  }

  function hideBanner() {
    const banner = document.getElementById(CONFIG.bannerId);
    if (banner) banner.remove();
  }

  function disableCheckout() {
    CONFIG.checkoutSelectors.forEach(function(sel) {
      document.querySelectorAll(sel).forEach(function(btn) {
        btn.disabled = true;
        btn.setAttribute('data-metal-disabled', 'true');
        btn.style.opacity = '0.5';
        btn.style.cursor  = 'not-allowed';
      });
    });
  }

  function enableCheckout() {
    CONFIG.checkoutSelectors.forEach(function(sel) {
      document.querySelectorAll(sel).forEach(function(btn) {
        if (btn.getAttribute('data-metal-disabled') === 'true') {
          btn.disabled = false;
          btn.removeAttribute('data-metal-disabled');
          btn.style.opacity = '1';
          btn.style.cursor  = 'pointer';
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', checkCartConflict);

  ['cart:updated', 'cart:refresh', 'theme:cart:add', 'cart:build'].forEach(function(evt) {
    document.addEventListener(evt, function() { scheduleCheck(400); });
  });

  ['theme:cart:open', 'cart:open', 'drawer:open', 'slideout:open'].forEach(function(evt) {
    document.addEventListener(evt, function() { scheduleCheck(700); });
  });

  document.addEventListener('click', function(e) {
    const isCheckout = CONFIG.checkoutSelectors.some(function(sel) {
      return e.target.matches(sel);
    });
    if (isCheckout) checkCartConflict();
  });

  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (!mutation.addedNodes.length) return;
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType !== 1) return;

        const watchSelectors = [
          'cart-drawer', '.cart-drawer__inner',
          '.cart-drawer', '#cart-drawer',
          'cart-items', '.cart__items', '#CartPageForm'
        ];

        const isCartNode = watchSelectors.some(function(sel) {
          return (node.matches && node.matches(sel)) ||
                 (node.querySelector && node.querySelector(sel));
        });

        if (isCartNode) scheduleCheck(600);
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  setInterval(checkCartConflict, 5000);

  window.MetalConflict = { check: checkCartConflict };

})();